module.exports = __webpack_public_path__ + "img/2.c649b16f.jpg";